/**
 * TanStack Query hooks for `anonymizer-tor-block`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	evaluate,
	list,
	remove,
	anonymizerTorBlockQueryKeys,
	type CreateAnonymizerTorBlockBody,
	type CreateAnonymizerTorBlockResponse,
	type EvaluateAnonymizerTorBlockBody,
	type EvaluateAnonymizerTorBlockResponse,
	type ListAnonymizerTorBlockResponse,
	type ListParams,
} from "./api";

export function useAnonymizerTorBlockList(
	params: ListParams = {},
): UseQueryResult<ListAnonymizerTorBlockResponse, Error> {
	return useQuery({
		queryKey: anonymizerTorBlockQueryKeys.list(params),
		queryFn: () => list(params),
	});
}

export function useAnonymizerTorBlockCreate(): UseMutationResult<
	CreateAnonymizerTorBlockResponse,
	Error,
	CreateAnonymizerTorBlockBody
> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: anonymizerTorBlockQueryKeys.all });
		},
	});
}

export function useAnonymizerTorBlockDelete(): UseMutationResult<
	{ ok: true },
	Error,
	string
> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: anonymizerTorBlockQueryKeys.all });
		},
	});
}

export function useAnonymizerTorBlockEvaluate(): UseMutationResult<
	EvaluateAnonymizerTorBlockResponse,
	Error,
	EvaluateAnonymizerTorBlockBody
> {
	return useMutation({
		mutationFn: evaluate,
	});
}
